import React from "react";
import "./index.css";

interface OrderSummaryStepProps {
  orderItems: any;
  setOrderItems: any;
  cartPersonWatcher: any;
  orderByWatcher: any;
  emailWatcher: any;
  phoneNumberWatcher: any;
  isLoading?: boolean;
  setPrice?: (price: number) => void;
  price: number;
  paymentDetails: any;
  isTentativeOrder: boolean;
  isDeliveryOrder?: boolean;
  manualDeliveryFee?: number;
}

const OrderSummaryStep: React.FC<OrderSummaryStepProps> = ({
  price,
  orderByWatcher,
  paymentDetails,
  isDeliveryOrder,
}) => {
  return (
    <>
      <div className="order-summary-step">
        <div className="summary-box">
          <h5>Order Summary</h5>
          <hr />
          <div className="summary-item">
            <span>Sub Total</span>
            <span>
              Rs.{" "}
              {orderByWatcher.value === "CartPerson"
                ? paymentDetails?.totalPrice !== undefined
                  ? paymentDetails.totalPrice.toFixed(2)
                  : (console.warn("totalPrice is undefined"), "0.00")
                : orderByWatcher.value === "User"
                  ? paymentDetails?.totalPrice !== undefined
                    ? paymentDetails.totalPrice.toFixed(2)
                    : (console.warn("totalPrice is undefined"), "0.00")
                  : orderByWatcher.value === "Organization"
                    ? paymentDetails?.totalPrice !== undefined
                      ? paymentDetails.totalPrice.toFixed(2)
                      : (console.warn("totalPrice is undefined"), "0.00")
                    : price.toFixed(2)}
            </span>
          </div>
          {!isDeliveryOrder && (
            <div className="summary-item">
              <span>Commission : </span>
              <span>
                Rs.{" "}
                {orderByWatcher.value === "CartPerson"
                  ? paymentDetails?.cartCommission !== undefined
                    ? paymentDetails.cartCommission.toFixed(2)
                    : (console.warn("cartCommission is undefined"), "0.00")
                  : orderByWatcher.value === "User"
                    ? paymentDetails?.cartCommission !== undefined
                      ? paymentDetails.cartCommission.toFixed(2)
                      : (console.warn("cartCommission is undefined"), "0.00")
                    : "0.00"}
              </span>
            </div>)}
          {isDeliveryOrder &&
            <div className="summary-item">
              <span>Delivery Fee : </span>
              <span>
                {paymentDetails?.isDeliveryFree ? (
                  <>
                    {/* show crossed original fee if available */}
                    {paymentDetails?.deliveryFee !== undefined && (
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "#fff",
                          marginRight: 8,
                        }}
                      >
                        Rs. {paymentDetails.deliveryFee.toFixed(2)}
                      </span>
                    )}
                    <span style={{ fontWeight: 600 }}>FREE</span>
                  </>
                ) : (
                  <>
                    Rs.{" "}
                    {paymentDetails?.deliveryFee !== undefined
                      ? paymentDetails.deliveryFee.toFixed(2)
                      : (console.warn("deliveryFee is undefined"), "0.00")}
                  </>
                )}
              </span>
            </div>
          }
          <div className="summary-item">
            <span>Discount : </span>
            <span>
              Rs.{" "}
                {paymentDetails?.discount !== undefined
                  ? paymentDetails.discount.toFixed(2)
                  : (console.warn("discountAmount is undefined"), "0.00")}
            </span>
            </div>
            <div className="summary-item total">
              <span>Total : </span>
              <span>
                Rs.{" "}
                {orderByWatcher.value === "CartPerson"
                  ? "0.00"
                  : paymentDetails?.netAmount !== undefined
                    ? paymentDetails.netAmount.toFixed(2)
                    : price.toFixed(2)}
              </span>
            </div>
          </div>
          {/* } */}
          <br />
        </div>
      </>
      );
};

      export default OrderSummaryStep;
